jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });
    // Hide storify popup
    $("#storeify-sl-btn-trigger-popup").hide();
    $("#storeify-sl-light-modal-wrapper").hide();

      $(".toggle-mob-sections").click(function () {
        $content = $('#sidemenu_canvas');
        if ($content.is(":visible")) {
			$content.slideUp(500);          
        } else {
			$content.slideDown(500);          
        }

      });

});